import React, {Component} from "react";
import {TextInput} from "../../../../../components";
import RemotingService from "../../../../../services/remoting-service/RemotingService";
import {Button, Col, Container, Row} from "react-bootstrap";


export default class PriorAuthorizationUpdateModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            priorAuthorizationId: props.priorAuthorizationId
        };
    }

    save = () => {
        RemotingService.postRemoteCall(
            `api/insurance/coordinator/v2/claims/claim/${this.props.claimId}/prior-authorization`,
            {priorAuthorizationId: this.state.priorAuthorizationId},
            () => {
                if (this.props.onSaved) {
                    this.props.onSaved();
                }
                if (this.props.close) {
                    this.props.close();
                }
            }
        );
    }

    render() {
        return (
            <Container style={{width: 400, padding: "20px"}}>
                <Row className="mb-3">
                    <Col>
                        <label className="font-weight-bold">Prior Authorization No</label>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <TextInput style={{width: "100%"}}
                                   value={this.state.priorAuthorizationId}
                                   onChange={(value) => this.setState({priorAuthorizationId: value})}/>
                    </Col>
                </Row>
                <Row>
                    <Col className="text-right">
                        <Button variant="success" onClick={this.save}>
                            Save
                        </Button>
                    </Col>
                </Row>
            </Container>
        );
    }
}
